/**
 * 分页hook, 用来简化分页操作
 */
import { useMemo, useState } from "react";
import { PaginationConfig } from "antd/lib/table/interface";
interface PaginationAntD {
    current: number;
    pageSize: number;
}

const DefaultPageSize = 20;

export default function usePagination(
    defaultPageSize: number = DefaultPageSize
) {
    const initPageNo = 1;

    const [pagination, setPagination] = useState<PaginationAntD>({
        current: initPageNo,
        pageSize: defaultPageSize
    });

    const tableProps = (total: number | undefined) => ({
        pagination: { ...pagination, total: total || 0 },

        onChange({ current, pageSize }: PaginationConfig) {
            setPagination({
                current: current || initPageNo,
                pageSize: pageSize || defaultPageSize
            });
        }
    });

    function gotoPage(current: number) {
        setPagination(pagination => ({ ...pagination, current }));
    }

    const params: PaginationConfig = useMemo(
        () => ({
            pageNo: pagination.current,
            pageSize: pagination.pageSize
        }),
        [pagination]
    );

    return { pagination, params, gotoPage, tableProps };
}
